import { StoreUtilService } from '@app/shared'
import { clean } from './cleanStore.metareducer'
import { logout } from './logout.metareducer'

export function getMetaReducers(storeService: StoreUtilService){
    return [clean(storeService), logout]
}